import axios from 'axios'

// S9.1 W9-01: nonce issuance writes a nonce row, so it is a POST.
// W10 S10.4 (MEV-584): the API no longer serves the deprecated GET (v2 answers
// 405, Node 404), so the client is POST-only. Every failure — 404/405, 400 bad
// address, 429/503 rate limit, 5xx, network error — propagates; nothing is
// retried as a GET.

export const WALLET_NONCE_PATH = '/auth/wallet/nonce'

export interface WalletNonce {
  nonce: string
  message: string
}

interface NonceResponse {
  success: boolean
  data?: WalletNonce
  error?: string
}

export async function fetchWalletNonce(address: string): Promise<WalletNonce> {
  const response = await axios.post<NonceResponse>(WALLET_NONCE_PATH, { address })
  if (!response.data?.success || !response.data.data) {
    throw new Error('Failed to get sign-in nonce.')
  }
  return response.data.data
}
